/**
 * Get popup html
 */
import Mustache from "mustache";
/* eslint-disable */

const popupHTML = (location) => {
    location = JSON.parse(location);
    location.location_title = location.location_title.startsWith("Industrious ") ? location.location_title.substring("Industrious ".length) : location.location_title;

    let contentString = [
        '<div class="marker-market-wrapper">',
        '{{#show_tag}}<span class="btn-squared-tag btn-squared-tag-xs label-tag" style="background:{{color_promo_banner}}; color:{{color_text_promo_banner}};">{{text_status}}</span>{{/show_tag}}',
        '<div class="swiper-container swiper-container--arrow-small swiper-container--white-arrow-fill marker-market-carousel-wrapper">',
        '<div class="swiper-wrapper">',
        "{{location}}",
        "{{#carousel_first_item}}",
        '<div class="swiper-slide">',
        '<a class="link-to-all gtm-view-details" href="{{permalink}}" data-location="{{location_title}}" aria-label="Go to {{location_title}}"></a>',
        "{{#sizes.marker_image}}",
        '<img class="js-lazy-load-image stretch-image" data-src="{{sizes.marker_image}}" />',
        "{{/sizes.marker_image}}",
        "{{^sizes.marker_image}}",
        '<img class="js-lazy-load-image stretch-image" data-src="{{carousel_first_item}}" />',
        "{{/sizes.marker_image}}",
        "</div>",
        "{{/carousel_first_item}}",
        "</div>",
        "<div class='swiper-pagination swiper-pagination-clickable swiper-pagination-bullets'><span class='swiper-pagination-bullet swiper-pagination-bullet-active'></span><span class='swiper-pagination-bullet'></span><span class='swiper-pagination-bullet'></span><span class='swiper-pagination-bullet'></span></div>",
        "<div class='swiper-button swiper-button-next swiper-button-disabled'><span class='icon arrow icon-hex-arrow-right' data-arrow='right arrow' tabindex='-1'></span></div><div class='swiper-button swiper-button-prev swiper-button-disabled'><span class='icon arrow icon-hex-arrow-left' data-arrow='left arrow' tabindex='-1'></span></div>",
        "</div>",
        '<div class="market-location-content">',
        '<a class="link-to-all gtm-view-details" href="{{permalink}}" data-location="{{location_title}}" aria-label="Go to {{location_title}}"></a>',
        '<div class="content-wrapper">',
        '<h3 class="marker-title font-weight-bold">{{location_title}}</h3>',
        "{{#inter_address}}",
        `<div class="address">${location.inter_address ? location.inter_address.replaceAll("\\n", "<br/>") : false}</div>`,
        "{{/inter_address}}",
        "{{^inter_address}}",
        "{{#address}}",
        '<div class="address">{{address}}</div>',
        "{{/address}}",
        '<div class="address">{{#city}} {{city}} ,{{/city}} {{#abbr}}{{abbr}}{{/abbr}} {{#zip}}{{zip}}{{/zip}}</div>',
        "{{/inter_address}}",

        "{{#show_phone}}",
        '<div class="phone-wrapper">',
        '<a class="phone" href="tel:{{phone}}">{{phone}}</a>',
        "</div>",
        "{{/show_phone}}",
        "</div>",
        '<div class="market-location-action">',
        "{{^office_price}}",
        '<div class="price-content"></div>',
        "{{/office_price}}",
        `<div class="see-location ml-auto"><a class="btn-link tertiary-text-color gtm-view-details" data-location="{{location_title}}" href="{{permalink}}">${window.js_translate.learn_more}</a></div>`,
        "</div>",
    ].join("\n");

    const htmlMarker = Mustache.render(contentString, location);

    return htmlMarker;
};

export default popupHTML;
